import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.css';

class DP extends React.Component {
    constructor(props) {
        super(props);
        const { date, label } = this.props;
        this.state = {
            startDate: date ? moment(date).toDate() : null,
            label: label ? label : '',
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(date) {
        console.log('change ---- ');
        const { setDate } = this.props;
        if (setDate) {
            setDate(date);
        }
        this.setState({
            startDate: date,
        });
    }

    render() {
        const { startDate } = this.state;
        return (
            <div className="DatePicker">
                <label htmlFor="feLastName">{this.state.label}</label>
                <DatePicker
                    selected={startDate}
                    onChange={this.handleChange}
                    placeholderText="DD/MM/YYYY"
                    showClearButton={false}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    openToDate={new Date('01-01-1980')}
                />
            </div>
        );
    }
}

export default DP;
